import { Link, Outlet, useParams } from "react-router-dom";
import { getForums } from "../data/forums";
import sortBy from "../util/sortBy";

export default function Forums() {
    const params = useParams();
    let forums = sortBy(getForums(), { prop: "forum_last_post_time", desc: true, parser: (d) => new Date(d) });

    return (
        <div>
            {!params.forumId && <>
                <h3 className="py-4 sticky bg-slate-200" style={{ top: "5.625rem" }}><Link className="no-underline text-slate-800" to="/">Forums</Link></h3>
                <table className="table-auto border-collapse border border-slate-400 w-full">
                    <thead className="bg-slate-700 text-slate-50 sticky" style={{ top: "149px" }}>
                        <tr>
                            <th className="text-left p-3 border border-slate-400">Title</th>
                            <th className="text-left p-3 border border-slate-400">Last Posted</th>
                        </tr>
                    </thead>
                    <tbody className="bg-slate-50">
                        {forums.filter(forum => forum.forum_posts > 0).map(forum => (
                            <tr key={forum.forum_id}>
                                <td className="text-left py-2 px-3 border border-slate-400">
                                    <Link className="no-underline text-slate-800" to={`/forums/${forum.forum_id}/topics`}>{forum.forum_name}</Link>
                                    <p className="text-sm max-w-lg">{forum.forum_desc}</p>
                                </td>
                                <td className="text-left py-2 px-3 border border-slate-400">
                                    {new Date(forum.forum_last_post_time).toLocaleString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>}
            <Outlet />
        </div>
    );
}